// extracted by mini-css-extract-plugin
export default {"root":"SearchInfoBanner_root__33Niw","headings":"SearchInfoBanner_headings__uW7Wz"};